// Spanish — top-level translations. Falls back to English for missing keys.
import en from "./en";

const es = {
  ...en,
  ui: {
    ...en.ui,
    brand: "My World Quest",
    brand_subtitle: "Colorea y Aprende",
    nav: {
      home: "Inicio", countries: "Países", globe: "Globo", continents: "Continentes",
      color: "Colorea", puzzles: "Puzzles", games: "Juegos", math: "Geo Mates",
      quiz: "Quiz", parents: "Padres", more: "Más",
     "geo-lines": "Líneas del mundo", "maths-academy": "Academia de Mates",},
    accessibility: { bigText: "Texto Grande", highContrast: "Alto Contraste" },
    navGroups: { quick: "Rápido", explore: "Explorar", play: "Jugar y aprender", collect: "Coleccionar", adv: "Aventura", grownup: "Para adultos" },
    actions: { back: "Atrás", close: "Cerrar", reset: "Reiniciar", save: "Guardar", retry: "Intenta de Nuevo", playAgain: "Jugar Otra Vez" },
  },
  microcopy: {
    ...en.microcopy,
    great: "¡Buen trabajo! ⭐",
    correct: "✅ ¡Correcto!",
    nope: "¡Intenta otra vez!",
    tryAgain: "Casi. ¡Sigue!",
    awesome: "¡Increíble!",
    welcome: "¡Bienvenido a {{country}}! Vamos a aprender {{language}}.",
    youDidIt: "¡Lo lograste!",
    perfect: "¡PERFECTO!",
  },
  home: {
    ...en.home,
    title1: "Explora el Mundo",
    title2: "Un País a la Vez",
    subtitle: "Aventuras geográficas divertidas, cuestionarios, desafíos y recompensas que ayudan a los niños a descubrir países, culturas, banderas, monumentos y más.",
    playNow: "Jugar Ahora →",
    takeQuiz: "Hacer un Quiz",
    openGlobe: "Abrir el Globo Grande →",
    globeHint: "¡Toca un punto brillante para aprender un país!",
    popularCountries: "O toca una bandera",
    whatNext: "¿Qué quieres hacer hoy?",
    whatNextSub: "Elige lo que quieras, ¡todo es divertido!",
    tiles: {
      ...en.home.tiles,
      learn: "Aprende Países", learnDesc: "¡30+ países con banderas!",
      globe: "Globo 3D", globeDesc: "Gira y toca para explorar",
      continents: "Continentes", continentsDesc: "Explora los 7 continentes",
      color: "Colorea Monumentos", colorDesc: "¡Colorea la Torre Eiffel!",
      math: "Mates Geográficas", mathDesc: "¡Suma km, cuenta países!",
      quiz: "Quiz", quizDesc: "Quiz básico y avanzado",
      parents: "Para Padres", parentsDesc: "Mira el progreso",
    },
  },
  learn: {
    title: "Aprende Países", capital: "Capital", language: "Idioma", hello: "Hola",
    learnIt: "¡Lo aprendí!", listen: "Escuchar",
    goalsEyebrow: "Objetivos de Aprendizaje de Hoy",
    goalsHeading: "🎯 Empieza por estos",
    goalsSubtitle: "Las cuatro cosas más importantes para dominar a los {{tier}} años — elegidas del currículo.",
    goalsAllTopics: "Ver todos los temas",
    goalsLearnNow: "Aprender ahora",
    goalsKey: "Clave #{{n}}",
    topicTitles: {
      "art-design": "Dibujo, Pintura y Diseño",
      "music": "Música: Ritmo, Canción y Notación",
      "computing-code": "Código, Algoritmos y Seguridad Digital",
      "physical-education": "EF, Salud y Ejercicio",
      "world-religions": "Religiones y Creencias del Mundo",
      "wellbeing-relationships": "Salud, Emociones y Amistades",
    },
  },
  globe: {
    title: "Globo 3D", subtitle: "Gira y toca para explorar",
    learnLang: "Aprender el idioma", moreInfo: "Más información", learnedTag: "✓ Aprendido",
    spinTap: "¡Gira el globo y toca un país!", spinTapSub: "Toca un pin para saber más.",
  },
  quiz: {
    title: "Quiz", basic: "Básico", advanced: "Avanzado",
    start: "Comenzar Quiz", next: "Siguiente →", finish: "¡Terminado!", score: "Puntuación",
  },
  stickers: { title: "Mi Álbum de Stickers", subtitle: "¡Colecciona un sticker de cada actividad!" },
  langSwitcher: {
    label: "Idioma",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  common: {
    whereToNext: "¿Hacia dónde ahora?",
    home: "Inicio",
    earnMoreStars: "⭐ Gana más estrellas",
    earnHowTo: "Juega un juego rápido — ¡cada uno suma XP a tu nivel!",
    pickAge: "Elegir edad",
    ages: "Edades",
    startExploring: "Comenzar a explorar",
    pickAnywhere: "Elige arriba — ¡o pulsa aquí!",
    tapAnyCountry: "¡Toca un país para descubrir su historia!",
    exploreGlobe: "Explorar el Globo",
    exploreGlobeSub: "Aventura 3D a pantalla completa",
  },
  shortcuts: {
    home: "Inicio",
    continents: "Continentes",
    globe: "Globo",
    ask: "Preguntar",
    landmarks: "Monumentos",
    flags: "Banderas",
    pixel: "Píxel",
    puzzles: "Rompecabezas",
    math: "Mates",
    trip: "Viaje",
    quiz: "Quiz",
    quests: "Misiones",
    stickers: "Pegatinas",
    miniGames: "Mini-juegos",
    geoMath: "Geo Mates",
    quickQuiz: "Quiz Rápido",
    myTrophies: "Mis trofeos",
    colorCreate: "Colorear y Crear",
    spinGlobe: "Girar el globo",
    askGlobe: "Pregunta al globo",
    dreamTrip: "Viaje Soñado",
    earnStars: "Ganar estrellas",
    tryAQuest: "Prueba una misión",
    playAgain: "Volver a jugar",
    learnCountry: "Aprender un país",
    colorLandmark: "Colorear monumento",
    learnCountries: "Aprender Países",
    advanced: "Modo Avanzado",
    spellCountry: "Adivina un país",
    advancedHub: "Zona avanzada",
    squishyHop: "Squishy Hop",
    mathSnap: "Math Snap",
    language: "Idioma",
    geoLines: "Líneas del mundo",
  },
  coloringExtra: {
    modeLandmarks: "Monumentos",
    modeFlags: "Artista de Banderas",
    modePixel: "Arte Píxel",
    diffEasy: "Fácil",
    diffMedium: "Medio",
    diffExpert: "Experto",
    difficultyLabel: "Dificultad:",
  },
  tilesExtra: {
    labelLearn: "Aprender",
    labelCreate: "Crear",
    labelPlay: "Jugar",
    labelTrophies: "Trofeos",
    whatNextSub: "Elige lo que quieras — ¡todo es divertido!",
  },
  pills: {
    orTry: "O prueba ↓",
    
    squishyHop: "Squishy Hop",
    mathSnap: "Snap matemático",colorLandmark: "Colorea un monumento",
    solvePuzzle: "Resuelve un rompecabezas",
    dreamTrip: "Planea un viaje soñado",
    geoMath: "Prueba geo mates",
    continentQuests: "Misiones por continente",
    stickerBook: "Álbum de pegatinas",
    famousPeople: "Conoce personas famosas",
    culturalSpot: "Foco cultural",
    quickQuiz: "Quiz rápido",
    continentMaps: "Mapas continentes",
    spellCountry: "Adivina un país",
    flagArtist: "Artista de banderas",
    pixelArt: "Pixel art",
    spinGlobe: "Girar el globo",
    askGlobe: "Pregunta al globo",
    myTrophies: "Mis trofeos",
    advancedHub: "Zona avanzada",
    geoLines: "Líneas del mundo",
  },
  canvas: {
    tools: "Herramientas",
    brushSize: "Tamaño pincel",
    colors: "Colores",
    patterns: "Patrones",
    modes: "Modos",
    solid: "Sólido",
    anyColor: "Otro color",
    recent: "Recientes",
    sticker: "Pegatina",
    symmetry: "Simetría",
    colorByNumber: "Colorea por número",
    reference: "Referencia",
    undo: "Deshacer",
    redo: "Rehacer",
    reset: "Borrar",
    replay: "Repetir",
    check: "Comprobar",
    save: "Guardar",
    fill: "Rellenar",
    pencil: "Lápiz",
    stamp: "Sello",
    erase: "Borrar",
    on: "ON",
    off: "OFF",
    tool: "Herramienta:",
    pattern: "patrón:",
    printOne: "Imprimir",
    downloadAll: "Descargar todo",
    appTitle: "Colorear y Crear 🎨",
    appSub: "¡Pinceles, patrones, pegatinas, colorear por número y más!",
  },
};

export default es;
